import { useTvViewershipStore } from "@/stores/TvViewershipStore";
import { useErrorStore } from "@/stores/ErrorStore";

export const TvRatingsStores = [useTvViewershipStore, useErrorStore];

export const TvRatingsChannel = {
  received(payload) {
    if (payload.status === "error" || payload.data?.status === "error") {
      const task = Object.keys(this.tvRatingStore.taskIds).find(
        (task) => this.tvRatingStore.taskIds[task] === payload.id,
      );
      if (task) {
        this.tvRatingStore.taskIds[task] = undefined;
        this.tvRatingStore.loading[task] = false;
        if (task === "ratings") {
          // set the error per tab
          this.tvRatingStore.errors.overview = payload.message;
          this.tvRatingStore.errors.ratings = payload.message;
          this.tvRatingStore.errors.daypart = payload.message;
        } else if (task === "avg_hours") {
          this.tvRatingStore.errors.avgHours = payload.message;
        } else if (task === "comparison") {
          this.tvRatingStore.errors.comparison = payload.message;
        } else {
          this.errorStore.showError(payload.message);
        }
      }
    }
    if (payload.id === this.tvRatingStore.taskIds.dates) {
      this.tvRatingStore.dates = payload.data.dates;
      this.tvRatingStore.loading.dates = false;
      this.tvRatingStore.taskIds.dates = undefined;
    }
    if (payload.id === this.tvRatingStore.taskIds.avg_hours) {
      this.tvRatingStore.loading.avg_hours = false;
      this.tvRatingStore.avgHours = payload.data;
      this.tvRatingStore.current = { ...this.tvRatingStore.filters };
      this.tvRatingStore.taskIds.avg_hours = undefined;
    } else if (payload.id === this.tvRatingStore.taskIds.ratings) {
      this.tvRatingStore.loading.ratings = false;
      this.tvRatingStore.setRatings(payload.data);
      this.tvRatingStore.current = { ...this.tvRatingStore.filters };
      this.tvRatingStore.taskIds.ratings = undefined;
    } else if (payload.id === this.tvRatingStore.taskIds.comparison) {
      this.tvRatingStore.loading.comparison = false;
      this.tvRatingStore.comparison = payload.data;
      this.tvRatingStore.taskIds.comparison = undefined;
    } else if (payload.id === this.tvRatingStore.taskIds.programs) {
      this.tvRatingStore.programs = payload.data.programs;
      this.tvRatingStore.taskIds.programs = undefined;
      this.tvRatingStore.loading.programs = false;
    } else if (payload.id === this.tvRatingStore.taskIds.comparisonPrograms) {
      this.tvRatingStore.comparisonPrograms = payload.data.programs;
      this.tvRatingStore.taskIds.comparisonPrograms = undefined;
      this.tvRatingStore.loading.comparisonPrograms = false;
    }
  },
};
